/**
 * @internal
 */
export async function readAll(input) {
    let output = '';
    for await (const chunk of input) {
        output += chunk;
    }
    return output;
}
//# sourceMappingURL=read-all.js.map